import ComingSoon from '../../../shared/ComingSoon';

export function OwnerDetailsProperties() {
  return <ComingSoon />;
}
